import React from "react";
import { Popover } from "antd";
import PatientChatHomePage from "./PatientChatHomePage";
import "./Chat.scss";

const PatientChatWidgetNewVersion = ({
  isLiveChatOpen,
  isAiBotChatOpen,
  chatDetails,
  clearChatDetails,
  clearAiBotChatDtls,
  closeChatWindow,
}) => {
  return (
    <div id="chat-pop-open-div" className="hidden-chat-pop-open-div">
      <Popover
        id="chat-popover"
        placement="leftTop"
        getPopupContainer={() => document.getElementById("chat-pop-open-div")}
        showArrow={false}
        open={true}
        content={
          <div className="patient-chat-content">
            <PatientChatHomePage
              closeChatWindow={closeChatWindow}
              isLiveChatOpen={isLiveChatOpen}
              isAiBotChatOpen={isAiBotChatOpen}
              chatDetails={chatDetails}
              clearChatDetails={clearChatDetails}
              clearAiBotChatDtls={clearAiBotChatDtls}
            />
          </div>
        }
      />
    </div>
  );
};
export default PatientChatWidgetNewVersion;
